import axios from "axios";
import { entrypoint } from "../../config/index.js";

export const axiosInstance = axios.create({
  baseURL: `${entrypoint}/`,
});

axiosInstance.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem("token"); // ou "jwt" selon ton projet
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export default axiosInstance;
